import { yupResolver } from '@hookform/resolvers/yup'
import { useAtomValue } from 'jotai'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { transferSchema } from 'pages/NestedCustomers/schema/transferSchema'
import { MovePayload } from 'pages/NestedCustomers/types'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'
import { generateReference } from 'utils/utils'
import { formDataAtom } from '../atoms/atoms'

export const useMoveFormState = () => {
  const { t } = useTranslation()
  const formSchema = transferSchema(t)
  const formData = useAtomValue(formDataAtom)

  const form = useForm<MovePayload>({
    resolver: yupResolver(formSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      walletTransferType: formData?.walletTransferType || WalletTransferType.MAIN,
      customerReference: formData?.customerReference || '',
      destinationWallet: formData?.destinationWallet || '',
      amount: formData?.amount || '',
      paymentReference: formData?.paymentReference || generateReference(),
    },
  })

  const formValues = form.watch()

  return {
    state: form.formState,
    values: formValues,
    register: form.register,
    setValue: form.setValue,
    trigger: form.trigger,
    clearErrors: form.clearErrors,
    setError: form.setError,
    watch: form.watch,
  }
}
